module.exports = function getResource(label) {
    const resources = {
        flashTermsConditionsLabel: 'Conditions générales de FLASH (obligatoire)',
        flashRenewsUnlessCancelMessage: 'Je reconnais que Sephora FLASH est un abonnement non remboursable qui se renouvelle automatiquement tous les 12 mois à moins que je ne l’annule.'
    };

    return resources[label];
};
